import header from "./components/header";
import heroSlider from "./components/heroSlider";
import animations from "./components/animations";
import accordion from "./components/accordion";
import videoPopup from "./components/videoPopup";
import testimonials from "./components/testimonials";
import scrolldir from "./components/scrolldir";
import map from "./components/map";
import imageGallery from "./components/imageGallery";
import infinitescroll from "./components/infinitescroll";
import iconTabs from "./components/iconTabs";
import mailchimp from "./components/mailchimp";
import alerts from "./components/alerts";
import imageLoad from "./components/imageLoad";
import userForm from "./components/userForms";


import app from "./app/app";

import cookieBar from "../../../../../vendor/smokeylemon/gdpr-basics/client/src/js/cookieBar";

document.addEventListener("DOMContentLoaded", () => {
    app();
    cookieBar();
    header();
    animations();
    accordion();
    videoPopup();
    scrolldir();
    map();
    infinitescroll();
    imageGallery();
    iconTabs();
    mailchimp();
    alerts();
    imageLoad();
});


window.addEventListener("load", () => {
    heroSlider();
    testimonials();
    userForm();
});
